module.exports = __webpack_public_path__ + "img/check_pass.9c992586.png";